import { Injectable } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'

export const BUSINESS_ROUTES = Object.freeze({
  HOME: '/home',
  ACCOUNT: '/account',
  NOT_FOUND: '/404',
  MANAGE_USERS: '/users',
  COMPANY_ACCOUNT: '/customer',
  LOGIN: '/auth/login',
  AUTH_RECOVER: '/auth/recover',
  REGISTRATION_REGISTER: '/registration/register',
  VERIFY_SUCCESS: '/actions/success/verifyEmail',
  PASSWORD_RESET_SUCCESS: '/actions/success/resetPassword',
})

@Injectable({ providedIn: 'root' })
export class BusinessNavigationService {
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  toLogin() {
    this.router.navigate([BUSINESS_ROUTES.LOGIN])
  }

  toHome() {
    this.router.navigate([BUSINESS_ROUTES.HOME])
  }

  toRecover() {
    this.router.navigate([BUSINESS_ROUTES.AUTH_RECOVER])
  }

  addQueryParams(queryParams: Params) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams,
      queryParamsHandling: 'merge',
    })
  }

  updateQueryParams(queryParams: Params) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams,
    })
  }
}
